module.exports = __webpack_public_path__ + "static/img/honor_two.12bcca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/honor_two.png
// module id = QSaq
// module chunks = 1